export const formatUsd = (value: number, fractionDigits = 2): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number.isFinite(value) ? value : 0);

export const parseDecimal = (raw: string): number => {
  const normalized = raw.replace(',', '.').trim();
  const value = Number.parseFloat(normalized);
  return Number.isFinite(value) ? value : 0;
};
